import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=57107298&scoped=true&"
import script from "./Skin.vue?vue&type=script&lang=js&"
export * from "./Skin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57107298",
  null
  
)

export default component.exports